import { faArrowsRotate, faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { GoogleAdsSmartCampaign } from '@feathr/blackbox';
import type { ISelectOption } from '@feathr/components';
import { AlertV2, Button, CardV2 as Card, EAlertV2Type, Form, Select } from '@feathr/components';
import type { TValidateGrouped } from '@feathr/rachis';

import * as styles from './GoalStep.css';

interface IGoalsProps {
  readonly campaign: GoogleAdsSmartCampaign;
}

export function validateGoalStep(campaign: GoogleAdsSmartCampaign): TValidateGrouped {
  // TODO: validate goals #2588 (need empty string to avoid validating fields on future steps)
  return campaign.validate([''], false, 'grouped').errors;
}

interface IGroupedOption {
  readonly label: string;
  readonly options: ISelectOption[];
}

// TODO: will integrate with backend #2588
const goalOptions: IGroupedOption[] = [
  {
    label: 'Business Goals',
    options: [
      {
        id: 'goal1',
        name: 'Goal 1',
      },
      {
        id: 'goal2',
        name: 'Goal 2',
      },
      {
        id: 'goal3',
        name: 'Goal 3',
      },
      {
        id: 'goal4',
        name: 'Goal 4',
      },
      {
        id: 'goal5',
        name: 'Goal 5',
      },
    ],
  },
  {
    label: 'Marketing Goals',
    options: [
      {
        id: 'goal6',
        name: 'Goal 6',
      },
      {
        id: 'goal7',
        name: 'Goal 7',
      },
      {
        id: 'goal8',
        name: 'Goal 8',
      },
      {
        id: 'goal9',
        name: 'Goal 9',
      },
      {
        id: 'goal10',
        name: 'Goal 10',
      },
    ],
  },
];

// TODO: remove eslint disable during integration #2588
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function GoalStep({ campaign }: IGoalsProps): JSX.Element {
  const { t } = useTranslation();
  const [goal, setGoal] = useState('');

  function handleGoalChange(goal: ISelectOption): void {
    setGoal(goal.id);
  }

  const selectedGoal = goalOptions.map((group) =>
    group.options.find((option) => option.id === goal),
  )[0];

  return (
    <div className={styles.root}>
      <Form label={t('Goals')}>
        <Card>
          <Card.Header
            /*
             * TODO: bring back during integration #2588
             * description={t(
             *   'You must sign in to your Google Ads account to create goals. After creating a goal, refresh the list below to select it.',
             * )}
             */
            title={t('Campaign Goal')}
          >
            <Button
              // TODO: remove disabled button #2588
              disabled={true}
              // TODO: should be external link to Google Ads goal configuration page - will handle in #2588
              href={'/'}
              name={'create-goal'}
              suffix={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
              target={'_blank'}
              type={'primary'}
            >
              {t('Create goal')}
            </Button>
          </Card.Header>
          <Card.Content>
            <AlertV2
              description={t('Please continue to the next step.')}
              title={t('Goals are coming soon.')}
              type={EAlertV2Type.info}
            />

            <Select<ISelectOption>
              // TODO: remove disabled button #2588
              disabled={true}
              label={t('Goal')}
              onSelectSingle={handleGoalChange}
              options={goalOptions}
              placeholder={t('Select a goal')}
              suffix={
                // TODO: remove disabled button #2588
                <Button disabled={true} type={'icon'}>
                  <FontAwesomeIcon icon={faArrowsRotate} />
                </Button>
              }
              suffixClassName={styles.suffix}
              value={selectedGoal}
            />
          </Card.Content>
        </Card>
      </Form>
    </div>
  );
}

export default observer(GoalStep);
